import ticketFilterQueryUtility from './ticketFilterQuery.utility.js'

/**
 * Scope vs filter query helpers for ticket workflow routes.
 * Scope (`ticketGroup`, `orgGroup`, tickets/tasks data mode, actor origin tab,
 * management list `layout`, tracking view tab) persists across management ↔ tracking;
 * searched filter params do not.
 */
function stripFilters(query = {}) {
  return ticketFilterQueryUtility.withFilters(query, {})
}

function isTicketManagementListPath(path) {
  if (typeof path !== 'string' || !path.includes('/tehtavat/hallinta')) return false
  return !/\/tehtavat\/hallinta\/[^/?#]+/.test(path)
}

function isTicketTrackingPath(path) {
  return typeof path === 'string' && path.includes('/tehtavat/seuranta')
}

function isManagementTrackingNavigation(fromPath, toPath) {
  return (
    (isTicketManagementListPath(fromPath) && isTicketTrackingPath(toPath)) ||
    (isTicketTrackingPath(fromPath) && isTicketManagementListPath(toPath))
  )
}

/** Stable query compare — key order must not trigger redirect loops. */
function queryEqual(a = {}, b = {}) {
  const keysA = Object.keys(a).sort()
  const keysB = Object.keys(b).sort()
  if (keysA.length !== keysB.length) return false
  return keysA.every((key, index) => key === keysB[index] && String(a[key]) === String(b[key]))
}

class TicketScopeQueryUtility {
  stripFilters(query) {
    return stripFilters(query)
  }

  isManagementTrackingNavigation(fromPath, toPath) {
    return isManagementTrackingNavigation(fromPath, toPath)
  }

  isTicketManagementListPath(path) {
    return isTicketManagementListPath(path)
  }

  isTicketTrackingPath(path) {
    return isTicketTrackingPath(path)
  }

  queryEqual(a, b) {
    return queryEqual(a, b)
  }
}

export default new TicketScopeQueryUtility()
